<template>
  <div 
    style="
      width: 100vw;
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;
    "
  >
    <h4>Please wait while signing in...</h4>
  </div>
</template>

<script>
export default {
  name: 'Callback'
}
</script>
